import { render } from "./EmployeeTable.vue?vue&type=template&id=26ba8b40"
import script from "./EmployeeTable.vue?vue&type=script&lang=ts"
export * from "./EmployeeTable.vue?vue&type=script&lang=ts"
script.render = render

export default script